import {account$} from "../emitters/account";

const CancelablePromise = require('mn-utils/CancelablePromise');
const noopHandle = require('mn-utils/noopHandle');
const request = require('mn-utils/browser/request');
const {
  API_URL_HTTP,
} = require('../config/api');
const isErrorNoConnect = require('../utils/isErrorNoConnect');
const {
  openPopupError,
} = require('../emitters/popup');


function methodProvider(init) {
  return (apiMethod, params, handleMock) => {
    params = params
      ? {...params}
      : {};
    const skipError = params.skipError;
    const handleError = params.handleError;
    if (skipError) {
      delete params.skipError;
    }
    if (handleError) {
      delete params.handleError;
    }
    return (
      process.env.MOCK
        ? CancelablePromise.delay(1000, {}).then(
          handleMock
            ? () => handleMock(params)
            : noopHandle,
        ) : init(apiMethod, params).then((response) => {
          const {
            error,
          } = response;
          if (error) {
            throw error;
          }
          return response.response;
        })
    )
        .catch((error) => {
          if (handleError) {
            return handleError(error);
          }
          throw error;
        })
        .catch((error) => {
          // console.log('error', error, error.message);

          const unathorisedTexts = [
            'Request doesn\'t have `Authorization` header or it\'s not valid',
            'Session is not valid'
          ];

          if (unathorisedTexts.includes(error.message) && account$.getValue()) {
            return account$.signOut();
          }


          // isErrorNoConnect(error) || skipError || openPopupError(error.message);
          isErrorNoConnect(error)
            && (error = {message: 'No network connection'});
          skipError || openPopupError(error.message);
          throw error;
        });
  };
}

export const post = methodProvider((apiMethod, params) => {
  const idempotenceKey = params.idempotenceKey;
  const confirmBearer = params.confirmBearer;
  const options = {
    mode: 'cors',
    cache: 'no-cache',
    method: 'POST',
    body: params,
  };
  if (idempotenceKey) {
    options.headers = {
      'Idempotence-Key': idempotenceKey,
    };
    delete params.idempotenceKey;
  }
  if (confirmBearer) {
    options.headers = {
      'confirmation-bearer': confirmBearer,
    };
    delete params.confirmBearer;
  }

  return request(API_URL_HTTP + apiMethod, options);
});

export const patch = methodProvider((apiMethod, params) => {
  const idempotenceKey = params.idempotenceKey;
  const confirmBearer = params.confirmBearer;
  const options = {
    mode: 'cors',
    cache: 'no-cache',
    method: 'PATCH',
    body: params,
  };
  if (idempotenceKey) {
    options.headers = {
      'Idempotence-Key': idempotenceKey,
    };
    delete params.idempotenceKey;
  }
  if (confirmBearer) {
    options.headers = {
      'confirmation-bearer': confirmBearer,
    };
    delete params.confirmBearer;
  }

  return request(API_URL_HTTP + apiMethod, options);
});

export const get = methodProvider((apiMethod, params) => {
  return request(API_URL_HTTP + apiMethod, {
    mode: 'cors',
    cache: 'no-cache',
    query: params,
  });
});
